import { post, get } from '@/base/http-base'

// 查询渠道商返佣明细
export function getPartnerUserList(params) {
  return post('/openApi/partner/getPartnerUserList', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//费用汇总
export function describeBillSummary(params) {
  return post('/openApi/partner/describeBillSummary', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//费用汇总
export function describeBillSummaryTrend(params) {
  return post('/openApi/partner/describeBillSummaryTrend', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 按产品和用户汇总
export function describeBillSummaryByPinAndProd(params) {
  return post('/openApi/partner/describeBillSummaryByPinAndProd', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 按账号汇总
export function describeBillSummaryByPin(params) {
  return post('/openApi/partner/describeBillSummaryByPin', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 按下级渠道商汇总
export function describeBillSummaryBySecondLevelDistributor(params) {
  return post(
    '/openApi/partner/describeBillSummaryBySecondLevelDistributor',
    params,
    {
      isLoading: false,
      isOutMsg: false,
    },
  )
}
// 按账号导出账单
export function exportBillSummaryByPin(params) {
  return post('/openApi/partner/exportBillSummaryByPin', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 按账号和产品导出账单
export function exportBillSummaryByPinAndProd(params) {
  return post('/openApi/partner/exportBillSummaryByPinAndProd', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//验证码
export function getCaptcha(params) {
  return get(
    '/localAPI/captcha',
    {
      ...params,
      time: new Date().valueOf(),
    },
    {
      isLoading: false,
      isOutMsg: false,
    },
  )
}
// 比较验证码
export function compareCaptcha(params) {
  return post('/localAPI/captcha', params, {
    isLoading: false,
  })
}
//按产品导出汇总账单
export function exportBillSummaryDetail(params) {
  return post('/openApi/partner/exportBillSummaryDetail', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//按产品汇总账单
export function describeBillSummaryDetail(params) {
  return post('/openApi/partner/describeBillSummaryDetail', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
// 查询地域
export function describeRegions(params) {
  return post('/openApi/billingbills/describeUserRegions', params)
}
// 查询账单明细数据
export function describeBillDetails(params) {
  return post('/openApi/partner/describeBillDetails', params)
}

//明细导出汇总账单
export function exportBillDetails(params) {
  return post('/openApi/partner/exportBillDetails', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

//资源账单列表
export function describeResourceBills(params) {
  return post('/openApi/partner/describeResourceBills', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//导出资源账单
export function exportResourceBills(params) {
  return post('/openApi/partner/exportResourceBills', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//渠道商资源账单列表
export function describeDistributorResourceBills(params) {
  return post('/openApi/partner/describeDistributorResourceBills', params)
}
//导出渠道商资源账单
export function exportDistributorResourceBill(params) {
  return post('/openApi/partner/exportDistributorResourceBill', params, {
    isLoading: false,
    isOutMsg: false,
  })
}
//渠道商结算账单费用总览
export function describeDistributorBillSummary(params) {
  return post('/openApi/partner/describeDistributorBillSummary', params, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 查询用户产品信息
export function getServiceCodes(options = {}) {
  return post('/openApi/partner/describeUserProducts', options, {
    isLoading: false,
    isOutMsg: false,
  })
}

// 按下级渠道商导出汇总账单
export function exportBillSummaryBySecondLevelDistributor(params) {
  return post(
    '/openApi/partner/exportBillSummaryBySecondLevelDistributor',
    params,
    {
      isLoading: false,
      isOutMsg: false,
    },
  )
}
